import { Link } from "react-router-dom";
import { Users, PawPrint } from "lucide-react";
import { Img } from "@/components/common/Primitives";
import { SIZES } from "@/lib/images";
import { useLang } from "@/lib/i18n";
import { minPrice } from "@/lib/content";
import { nok } from "@/lib/format";
import { BADGE_LABELS } from "@/lib/booking";

/** Photo-first room card (listing-style) */
export const RoomCard = ({ rt, building, testid, eager = false, aspect = "aspect-[4/3]" }) => {
  const { lang, tx, tr } = useLang();
  const id = testid || `room-card-${rt.id}`;
  const badge = (rt.badges || []).find((b) => ["sea_view", "best_value", "step_free"].includes(b));
  return (
    <Link to={`/rom/${rt.slug}`} className="group block rounded-[22px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4" data-testid={id}>
      <div className="relative">
        <Img src={rt.images?.[0]} alt={tr(rt.name)} className={`img-zoom ${aspect}`} radius="rounded-[22px]" eager={eager} sizes={SIZES.third} />
        {badge && <span className="absolute left-3 top-3 rounded-full bg-white/95 px-3 py-1.5 text-xs font-semibold text-foreground shadow-float backdrop-blur">{tr(BADGE_LABELS[badge])}</span>}
      </div>
      <div className="mt-4 flex items-start justify-between gap-4">
        <div className="min-w-0">
          {building && <p className="text-xs font-medium text-muted-foreground">{tr(building.name)}</p>}
          <h3 className="mt-0.5 text-[1.0625rem] font-semibold leading-snug tracking-[-0.015em] text-foreground">{tr(rt.name)}</h3>
          <p className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted-foreground">
            <span className="inline-flex items-center gap-1"><Users className="h-3.5 w-3.5" strokeWidth={1.75} /> {tx(`Inntil ${rt.max_guests} ${rt.max_guests === 1 ? "gjest" : "gjester"}`, `Up to ${rt.max_guests} ${rt.max_guests === 1 ? "guest" : "guests"}`)}</span>
            {rt.dogs_allowed && <span className="inline-flex items-center gap-1"><PawPrint className="h-3.5 w-3.5" strokeWidth={1.75} /> {tx("Hund velkomen", "Dogs welcome")}</span>}
          </p>
        </div>
        <p className="shrink-0 text-right">
          <span className="block text-[1.0625rem] font-semibold tnum text-foreground" data-testid={`${id}-price`}>{nok(minPrice(rt), lang)}</span>
          <span className="block text-xs text-muted-foreground">{tx("per natt · frukost inkludert", "per night · breakfast included")}</span>
        </p>
      </div>
    </Link>
  );
};
